module.exports = __webpack_public_path__ + "static/media/cozy9016.29eaba51.jpg";